class yangShanXianWenHuaGuan {
  constructor(vue) {
    this.vue = vue
    this.wrapperName = "yangShanXianWenHuaGuan"
    this.index = 0
    this.toolTipData = null
    this.intervalHandle = null
  }
  async init() {
    await this.initData()
    this.startCreateToolTip()
    this.intervalHandle = setInterval(() => {
      this.index = this.index >= this.toolTipData.length - 1 ? 0 : this.index + 1
      this.startCreateToolTip()
    }, 30000)
  }
  startCreateToolTip() {
    this.clearOldWrapper() //清空老的dom
    const newWrapper = this.createToolTip() //创建框
    console.log(newWrapper)
    this.vue.$el.appendChild(newWrapper) //push到当前容器中
  }
  async initData() {
    let toolTipData = await (this.vue.options?.restDataUrl?.length
      ? this.vue.instance.get(this.vue.options.restDataUrl)
      : Promise.resolve(null))
    console.log("object :>> ", toolTipData)
    if (!toolTipData?.data?.data?.content?.data) {
      toolTipData = [
        {
          name: "阳山县文化馆",
          data: [
            {
              key: "建筑面积",
              value: "148m2"
            },
            {
              key: "开放时间",
              value: "8:00-9:00"
            },
            {
              key: "地址",
              value: "阿松大骄傲欸去年我脾气我覅披风分配我我"
            }
          ]
        },
        {
          name: "山羊县文化馆",
          data: [
            {
              key: "建筑面积",
              value: "48m2"
            },
            {
              key: "开放时间",
              value: "18:00-19:00"
            },
            {
              key: "地址",
              value: "而也让他合伙人特别放松放松"
            }
          ]
        }
      ]
    } else {
      toolTipData.data.data.content.data.forEach(data => {
        data.data = data.data.filter(it => it.value.length && it.value !== "暂无")
      })
      toolTipData = toolTipData.data.data.content.data
    }
    this.toolTipData = toolTipData
  }
  createToolTip() {
    const data = this.toolTipData[this.index]
    const wrapper = this.createWrapper()
    wrapper.appendChild(this.createTitle(data.name))
    wrapper.appendChild(this.createContent(data.data))
    return wrapper
  }
  createContent(data) {
    const el = document.createElement("div")
    data.forEach(item => {
      el.appendChild(this.createContentItem(item))
    })
    return el
  }
  createContentItem(data) {
    const item = document.createElement("div")
    const left = document.createElement("span")
    const right = document.createElement("span")
    left.innerText = data.key + ":"
    right.innerText = data.value
    this.createStyle(left, {
      color: "rgb(193,218,236)",
      textAlign: "left",
      marginRight: "8px"
    })
    this.createStyle(right, {
      color: "rgb(231,241,168)",
      textAlign: "left",
      marginRight: "4px"
    })
    this.createStyle(item, {
      marginTop: "8px"
    })
    item.appendChild(left)
    item.appendChild(right)
    return item
  }
  createTitle(name) {
    const el = document.createElement("div")
    this.createStyle(el, {
      textAlign: "center",
      color: "rgb(84,218,236)",
      fontSize: "16px",
      lineHeight: "16px",
      height: "26px",
      width: "80%",
      padding: "2px 0px",
      borderBottom: "2px solid rgb(84,218,236)"
    })
    el.innerText = name
    return el
  }
  createWrapper() {
    const el = document.createElement("div")
    this.createStyle(el, {
      width: "30%",
      padding: "12px 24px",
      position: "absolute",
      left: "50px",
      top: "20%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      background: "rgb(28,61,95,0.8)",
      borderRadius: "10px",
      border: "1px solid rgb(106,140,172)"
    })
    return el
  }
  createStyle(el, style) {
    for (let k in style) {
      el.style[k] = style[k]
    }
  }
  clearOldWrapper() {
    const oldEl = this.vue.$el.getElementsByClassName(this.wrapperName)[0]
    if (oldEl) {
      this.vue.$el.removeChild(oldEl)
    }
  }
}
export default {
  data() {
    return {
      yangShanXianWenHuaGuan: new yangShanXianWenHuaGuan(this)
    }
  },
  methods: {
    async yangShanXianWenHuaGuanPlugin() {
      await this.yangShanXianWenHuaGuan.init()
    }
  },
  beforeDestroy() {
    clearInterval(this.yangShanXianWenHuaGuan.intervalHandle)
  }
}
